var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-235.69,24.25a1.22,1.22,0,0,1-.84-.35,1.19,1.19,0,0,1-.35-.84V-3.06a1.25,1.25,0,0,1,.16-.6,1.32,1.32,0,0,1,.44-.44,1.2,1.2,0,0,1,.59-.15,1.24,1.24,0,0,1,.6.15L-212.53,9a1.21,1.21,0,0,1,.44.43,1.25,1.25,0,0,1,.16.6,1.25,1.25,0,0,1-.16.6,1.21,1.21,0,0,1-.44.43L-235.09,24.1A1.24,1.24,0,0,1-235.69,24.25ZM-234.5-1V21l19-11Z","transform":"translate(237.13 4.5)"}));
}

PlayIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 25.45 29"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
